import { render } from "./HazLicenseList.vue?vue&type=template&id=272ead79"
import script from "./HazLicenseList.vue?vue&type=script&lang=js"
export * from "./HazLicenseList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__